export default __webpack_public_path__ + "static/media/reviewPic3.fa2528a9.svg";